import { render, staticRenderFns } from "./ResendButton.vue?vue&type=template&id=1a2ea126&lang=pug"
import script from "./ResendButton.vue?vue&type=script&lang=js"
export * from "./ResendButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports